import { render } from "./MyMusicXmlCate.vue?vue&type=template&id=48829d60"
import script from "./MyMusicXmlCate.vue?vue&type=script&lang=js"
export * from "./MyMusicXmlCate.vue?vue&type=script&lang=js"

import "./MyMusicXmlCate.vue?vue&type=style&index=0&id=48829d60&lang=less"

import exportComponent from "F:\\TheDreamMusic\\aimusicxml\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__